module.exports = __webpack_public_path__ + "static/media/offset.f494f6bb.jpg";